import CreateProspectModal from "./createProspectModal";

export default CreateProspectModal;
